'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _Dropdown = require('../../blocks/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Content(_ref, context) {
  var children = _ref.children,
      modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['children', 'modifiers']);

  var _context$DROPDOWN_CON = context[_constants.DROPDOWN_CONTEXT],
      arrow = _context$DROPDOWN_CON.arrow,
      fullWidth = _context$DROPDOWN_CON.fullWidth,
      position = _context$DROPDOWN_CON.position,
      removeOnHide = _context$DROPDOWN_CON.removeOnHide,
      showContent = _context$DROPDOWN_CON.showContent,
      zIndex = _context$DROPDOWN_CON.zIndex;


  if (!showContent && removeOnHide) {
    return null;
  }

  var fw = (0, _lodash.compact)([fullWidth && 'fullWidth']);
  var contentModifiers = fw.concat.apply(fw, [position].concat(_toConsumableArray(modifiers)));
  var hideContent = !showContent && !removeOnHide;

  return _react2.default.createElement(
    _Dropdown2.default.Content,
    _extends({
      arrow: arrow,
      modifiers: contentModifiers,
      hideContent: hideContent,
      zIndex: zIndex
    }, rest),
    children,
    arrow && _react2.default.createElement(_Dropdown2.default.Arrow, { modifiers: [position] })
  );
}

Content.displayName = 'Dropdown__Content';

Content.contextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);

Content.defaultProps = {
  modifiers: []
};

Content.propTypes = {
  children: _propTypes2.default.node.isRequired,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Content;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Dropdown/Content.js
// module id = 1653
// module chunks = 2